import React, { useState, useEffect } from "react";
import { number } from "prop-types";
import { Link } from "@quintype/components";
import { connect } from "react-redux";
import { get } from "lodash";

import AlsoRead from "../../rows/also-read";

import { getWruStories } from "../../helper/api";
import { readCookie } from "../../helper/cookies";

import "./notFound.m.css";

const NotFoundPageView = ({ merchantId }) => {
  const [alsoReadStories, setAlsoReadStories] = useState(null);

  useEffect(() => {
    if (!(alsoReadStories && alsoReadStories.length)) {
      const thinmint = readCookie("thinmint");

      getWruStories(merchantId, thinmint, "qwnotfound").then((response) => {
        const items = (response.length && response[0].recommendations) || [];
        setAlsoReadStories(items);
      });
    }
  }, []);

  return (
    <div styleName="wrapper" className="container">
      <div styleName="content-wrapper">
        <div styleName="image-wrapper">
          <img
            styleName="image"
            src="https://images.assettype.com/thequint/2020-08/7c8dd01f-d051-477f-975d-1bc7d5c02dd1/yoda_New.jpg?rect=0%2C0%2C2000%2C1125&auto=format%2Ccompress&w=800&format=webp&dpr=1.0"
          />
        </div>
        <div styleName="content">
          <span styleName="error-code-msg">Error Code: 404</span>
          <span styleName="main-title">
            We Looked Everywhere
            <br />
            For This Page!
          </span>
          <Link styleName="go-back-btn" href="/">
            Go back to homepage
          </Link>
        </div>
      </div>

      <AlsoRead list={alsoReadStories} merchantId={merchantId} name="Not Found Page" />
    </div>
  );
};

NotFoundPageView.propTypes = {
  merchantId: number,
};

const mapStateToProps = (state) => ({
  merchantId: get(state, ["qt", "config", "publisher-attributes", "wru_id"]),
});

const NotFoundPage = connect(mapStateToProps, null)(NotFoundPageView);

export { NotFoundPage };
